module.exports = __webpack_public_path__ + "static/media/32_B.d5ca4025.png";